import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import Vuetify from './plugins/vuetify';
import VueKeen from './plugins/keen-tracking';

Vue.config.productionTip = false;

Vue.use(VueKeen, {
  projectId: process.env.NODE_ENV === 'production' ? '5dbb1599c9e77c0001707032' : '5db0f3e3c9e77c000170658f',
  writeKey: process.env.NODE_ENV === 'production' ? '56B57BD9C7A5D41E43502988495BC80147C66D8E85AA81D0DD858548A1EF6BB8857C6BA09E4A98EEE45D51219A361B5FFEA63D9DAD38D4AA87DEC504FB90204D2D8AEB6D90C7CC1FD958CBC5D62DAAD3053A487FF6184A2CC48595DD9D32CB33' : '6B7AF66AF0F0E4CE0F9CC18DE24422B8AEC1ECD9C744F5D6F99C86293AEF0FA667BBB1B7DACD435E95AA620C222B9AAE3B88FC79F204D135D666378A00C86F81D894FBAAF7E3AF78050FE12CD51B0F21A74D125BE27384A323CF2642579E7F0D',
  autoTracking: false,
  collectUuid: true,
});

new Vue({
  store,
  router,
  vuetify: Vuetify,
  render: h => h(App),
}).$mount('#app');
